import {IHttpService} from "angular";
import {OptionChainResponse} from "../models/OptionChainRecord";

export class OptionsService {

    public static readonly id = "optionsService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {
    }

    public async retrieve(): Promise<OptionChainResponse> {
        const url = `/tradefloor/api/market/AOM/contracts`;
        const options = {ignoreLoadingBar: true};
        const response = await this.$http.get<OptionChainResponse>(url, options);
        return response.data;
    }
}
